import React, {Fragment} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from "redux";

import createLink from "../../libs/createLink";

import {fetchUserRandomQuestions, resetUserRandomQuestions} from "../../creators/users.randomQuestions";

import QuestionCard from './QuestionCard';
import Icon from './Icon';
import Alert from './Alert';
import {Button} from "./Button";
import {createUserFriendsRequest} from "../../creators/user.friendsRequest";
import {PageLoader} from "./Loader";

class QuestionCardList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            currentIndex: 0,
            questionList: [],
            hasDoneQuestion: false,
            lengthLimit: 2
        };
        this.handleMessage = this.handleMessage.bind(this);
        this.handleKeyPress = this.handleKeyPress.bind(this);
        this.nextQuestion = this.nextQuestion.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.props.fetchUserRandomQuestions(this.props.user._id);
    }

    componentDidMount() {
        this.setState({questionList: this.props.userRandomQuestions});
    }


    componentDidUpdate(prevProps, prevState, snapshot) {
        if(prevProps.userRandomQuestions !== this.props.userRandomQuestions){
            this.setState({questionList: this.props.userRandomQuestions});
        }
    }

    componentWillUnmount() {
        this.props.resetUserRandomQuestions();
    }

    handleMessage(event, index) {
        let questionList = this.state.questionList;
        questionList[index] = {...questionList[index], answer: event.target.value};
        this.setState({questionList: questionList});
    }

    nextQuestion(type) {
        this.setState(prevState => {
            return {currentIndex: type === 'next' ? prevState.currentIndex + 1 : prevState.currentIndex - 1}
        });
    }

    handleKeyPress(event, index) {
        let questionList = this.state.questionList;
        if (event.key === "Enter") {
            if ((this.state.currentIndex !== (this.state.questionList.length - 1)) && questionList[index].answer.length >= this.state.lengthLimit) {
                this.nextQuestion('next');
            }
            if ((this.state.currentIndex === (this.state.questionList.length - 1)) && questionList[index].answer.length >= this.state.lengthLimit) {
                this.setState({hasDoneQuestion: true})
            }
        }
    }

    onSubmit() {
        let questions = [];
        this.state.questionList.forEach(item => {
            questions.push({
                answer: item.answer,
                question: item.content
            })
        });
        let data = {
            contents: questions
        };
        this.props.createUserFriendsRequest(this.props.user._id, data);
        this.setState({hasDoneQuestion: true});
        if(typeof this.props.handleFriendPendingState === 'function') this.props.handleFriendPendingState();
        this.props.handleClose();
    }

    render() {
        let item = this.state.questionList[this.state.currentIndex];
        let questions = [...this.props.currentUser.question.couple,
                        ...this.props.currentUser.question.facondetre,
                        ...this.props.currentUser.question.femme,
                        ...this.props.currentUser.question.general,
                        ...this.props.currentUser.question.homme,
                        ...this.props.currentUser.question.vousetmoi];
        return !this.props.userRandomQuestionsInitialized ? (
            <div className="row list-container">
                <PageLoader />
            </div>
        ) : (
            <div className="row list-container">
                {this.state.questionList.length >= 1 ? (
                    <Fragment>
                        {this.state.hasDoneQuestion ? (
                            <div className="question-sent">
                                {this.props.user.username} doit valider vos questions avant de devenir ami.
                                <Icon type="coffee"/>
                                <Button size={"small"}
                                        btnStyle={"primary-reverse"}
                                        onClick={this.props.handleClose}
                                        content={"Valider"}/>
                            </div>
                        ) : (
                            <div className="question-card-list">
                                <div className="question-card-wrapper">
                                  <span
                                      className="nb-questions">{(this.state.currentIndex + 1)} / {this.state.questionList.length}</span>
                                    <QuestionCard
                                        question={item.content}
                                        answer={item.answer || ""}
                                        index={this.state.currentIndex}
                                        handleMessage={this.handleMessage}
                                        handleKeyPress={this.handleKeyPress}
                                        lengthLimit={this.state.lengthLimit}
                                    />
                                </div>
                                {this.props.userRandomQuestionsError.message && (
                                    <div>{this.props.userRandomQuestionsError.message}</div>)}
                                {this.state.currentIndex === 0 && this.state.questionList.length > 1  ? (
                                    <div className="btn-group">
                                        <Button size={"small"}
                                                btnStyle={"grey"}
                                                onClick={this.props.handleClose}
                                                content={"Annuler"}/>
                                        <Button
                                            className={item.answer && item.answer.length >= this.state.lengthLimit ? 'next' : ''}
                                            size={"small"}
                                            disabled={!(item.answer && item.answer.length >= this.state.lengthLimit)}
                                            btnStyle={"primary-reverse"}
                                            onClick={item.answer && item.answer.length >= this.state.lengthLimit ? (this.nextQuestion.bind(this, 'next')) : null}
                                            content={"Suivant"}/>
                                    </div>
                                ) : this.state.questionList.length === 1 ? (
                                    <div className="btn-group">
                                        <Button size={"small"}
                                                btnStyle={"grey"}
                                                onClick={this.props.handleClose}
                                                content={"Annuler"}/>
                                        <Button
                                            className={item.answer && item.answer.length >= this.state.lengthLimit ? 'send' : ''}
                                            size={"small"}
                                            disabled={!(item.answer && item.answer.length >= this.state.lengthLimit)}
                                            btnStyle={"primary-reverse"}
                                            onClick={() => this.onSubmit()}
                                            content={"Envoyer la demande d’amitié"}/>
                                    </div>
                                ) : this.state.currentIndex === (this.state.questionList.length - 1) ? (
                                    <div className="btn-group">
                                        <Button size={"small"}
                                                btnStyle={"grey"}
                                                onClick={this.props.handleClose}
                                                content={"Annuler"}/>
                                        <Button size={"small"}
                                                btnStyle={"grey"}
                                                onClick={this.nextQuestion.bind(this, 'previous')}
                                                content={"Précédent"}/>
                                        <Button
                                            className={item.answer && item.answer.length >= this.state.lengthLimit ? 'send' : ''}
                                            size={"small"}
                                            btnStyle={"primary-reverse"}
                                            disabled={!(item.answer && item.answer.length >= this.state.lengthLimit)}
                                            onClick={() => this.onSubmit()}
                                            content={"Envoyer la demande d’amitié"}/>
                                    </div>
                                ) : (
                                    <div className="btn-group">
                                        <Button size={"small"}
                                                btnStyle={"grey"}
                                                onClick={this.props.handleClose}
                                                content={"Annuler"}/>
                                        <Button size={"small"}
                                                btnStyle={"grey"}
                                                onClick={this.nextQuestion.bind(this, 'previous')}
                                                content={"Précédent"}/>
                                        <Button
                                            className={item.answer && item.answer.length >= this.state.lengthLimit ? 'next' : ''}
                                            size={"small"}
                                            disabled={!(item.answer && item.answer.length >= this.state.lengthLimit)}
                                            btnStyle={"primary-reverse"}
                                            onClick={item.answer && item.answer.length >= this.state.lengthLimit ? (this.nextQuestion.bind(this, 'next')) : null}
                                            content={"Suivant"}/>
                                    </div>
                                )}
                                {questions.length === 0 && (
                                    <div className="and-you-question">
                                        <span
                                            className="mb-8">{this.props.currentUser && this.props.currentUser.username}... Et vous ?</span>
                                        <Button size={"small"}
                                                to={createLink("userMeSettingsFriendsAndRequest")}
                                                content={"Choisissez les questions posées à ceux qui veulent faire votre connaissance"}/>
                                    </div>
                                )}
                            </div>
                        )}
                    </Fragment>
                ) : (
                    <Alert text={`Voulez vous vraiment ajouter ${this.props.user && this.props.user.username} ?`}
                           handleDelete={() => this.onSubmit()} handleClose={() => this.props.handleClose()}/>
                )}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        userRandomQuestions: state.userRandomQuestions.data,
        userRandomQuestionsLoading: state.userRandomQuestions.loading,
        userRandomQuestionsInitialized: state.userRandomQuestions.initialized,
        userRandomQuestionsError: state.userRandomQuestions.error
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchUserRandomQuestions,
    createUserFriendsRequest,
    resetUserRandomQuestions
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(QuestionCardList);
